module.exports = __webpack_public_path__ + "img/circle_blue_left.4d56d73f.png";